import React from "react";

function WhyChooseShivaPDF() {
  return (
    <div className="container text-start">
      {/* Title */}
      <div style={{ marginTop: "6rem" }}>
        {" "}
        <label className="display-6 fw-bold text-dark">
          Why choose Shivapdf?
        </label>
      </div>

      {/* Caused */}
      <div className="row mt-5">
        {/* Trust */}
        <div className="col-md-4">
          <div className="card border-0 justify-content-center text-center">
            <img
              loading="lazy"
              src="./images/people.png"
              className="card-img-top mx-auto"
              alt="people"
              style={{ width: "200px", height: "200px" }}
            />
            <div className="card-body">
              <h5 className="card-title">Trusted by many</h5>
              <p className="card-text text-muted">
                Over a million users have used our service to simplify their
                work with digital documents.
              </p>
            </div>
          </div>
        </div>

        {/* Privacy */}
        <div className="col-md-4">
          <div className="card border-0 justify-content-center text-center">
            <img
              loading="lazy"
              src="./images/privacy.png"
              className="card-img-top mx-auto"
              alt="people"
              style={{ width: "200px", height: "200px" }}
            />
            <div className="card-body">
              <h5 className="card-title">Privacy & Protect</h5>
              <p className="card-text text-muted">
                All your documents are stored and processed in our secured
                storage and automatically deleted just after converting.
              </p>
            </div>
          </div>
        </div>

        {/* Support */}
        <div className="col-md-4">
          <div className="card border-0 justify-content-center text-center">
            <img
              loading="lazy"
              src="./images/support.png"
              className="card-img-top mx-auto"
              alt="people"
              style={{ width: "200px", height: "200px" }}
            />
            <div className="card-body">
              <h5 className="card-title">24 x 7 Support</h5>
              <p className="card-text text-muted">
                Get all the help you need with our round-the-clock customer
                support.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WhyChooseShivaPDF;
